export const getApiUrl = (...args: string[]): string => {
  if (args.length !== 1) {
    throw new Error('wrong number of arguments for utils.getApiUrl');
  }
  return args[0];
};

type FormDataValuePrimitive = string | number | boolean | null;
type FormDataValueLeaf = FormDataValuePrimitive | Record<string, FormDataValuePrimitive>;
export type FormDataValue = FormDataValueLeaf | Blob | FormDataValueLeaf[] | File[];

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export const transformFormData = (formValues: Record<string, FormDataValue>): FormData => {
  const formData = new FormData();
  Object.entries(formValues).forEach(([key, value]) => {
    if (value instanceof File) {
      formData.append(key, value, value.name);
      return;
    }
    if (value instanceof Blob) {
      formData.append(key, value);
      return;
    }
    // true', 'falseのままで送信するとサーバー側ではいずれもtrueになるため、
    // サーバサイドでboolvalを利用する前提で'1', '0'で送信する。
    if (typeof value === 'boolean') {
      formData.append(key, value ? '1' : '0');
    } else if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        const elem = value[i];
        if (elem instanceof File) {
          formData.append(`${key}[]`, elem, elem.name);
          continue;
        }
        if (elem instanceof Blob) {
          formData.append(`${key}[]`, elem);
          continue;
        }
        if (isRecord(elem)) {
          const objKeys = Object.keys(elem);
          for (const objKey of objKeys) {
            const objValue = elem[objKey];
            formData.append(`${key}[][${objKey}]`, (objValue ?? '').toString());
          }
        } else {
          formData.append(`${key}[]`, (elem ?? '').toString());
        }
      }
    } else {
      formData.append(key, isRecord(value) ? JSON.stringify(value) : (value ?? '').toString());
    }
  });
  return formData;
};
